import ErrorPage from '@/components/ErrorPage';

export default function Error503() {
  return (
    <ErrorPage
      errorCode="503"
      title="We're Cooking Something Special"
      message="Our servers are temporarily unavailable while we prepare something delicious. Please check back in a few moments."
      imagePath="/error-503.png"
      showRefresh={true}
    />
  );
}